import React from 'react';
import { useNavigate } from 'react-router-dom';
import EULAModal from '../components/EULAModal.jsx';

const EulaPage = ({ handleEULAAccept, eulaContent }) => {
    const navigate = useNavigate();
    const onAccept = async () => {
        try {
            await handleEULAAccept();
            navigate('/app/home', { replace: true });
        } catch (_) {
            navigate('/app/home', { replace: true });
        }
    };

    return (
        <div style={{ minHeight: '100vh' }}>
            <EULAModal onAccept={onAccept} eulaContent={eulaContent} />
        </div>
    );
};

export default EulaPage;


